import { FormControl } from '@angular/forms';

export interface CountryRegion {
  country_code?: string[];
  region_code?: string[];
}

export interface CountryRegionForm {
  country_code: FormControl<string[]>;
  region_code: FormControl<string[]>;
}

export interface RegionOptionsByGroup {
  label: string;
  value: string;
  group: string;
}

export const ADD_ITEM_PREFIX = 'Add Item';

export const isCountryRegion = (value: any) => {
  return (
    typeof value === 'object' &&
    Object.prototype.hasOwnProperty.call(value, 'country_code') &&
    Object.prototype.hasOwnProperty.call(value, 'region_code')
  );
};
